export const generateDataStat = (stat: string, isSmall: boolean) => {
  if (!stat) return null;

  return `${stat}${isSmall ? '_mobile' : ''}`;
};
